import { Injectable } from '@angular/core';
import { GumUsersService } from './gumservices/gum-users.service';
import { Property } from '../models/property';
import { MODULE_TYPES, NexusModule } from '../models/enum/nexus-module';

@Injectable({ providedIn: 'root' })
export class NexusAccessService {
  constructor(private usersService: GumUsersService) {}

  private getProperty(name: string): string | undefined {
    const user = this.usersService.getCurrentUserSync();
    return user?.properties?.find((p) => p.name.trim() === name)?.value;
  }

  canAccess(module: NexusModule): boolean {
    const propName = `Nexus${module}`;
    const value = this.getProperty(propName);

    if (!value) return false;

    const type = MODULE_TYPES[module];

    if (type === 'application') {
      const level = parseInt(value.split('-')[0].trim(), 10);
      return level > 0;
    }

    if (type === 'function') {
      return value === '1';
    }

    return false;
  }

  isReadOnly(module: NexusModule): boolean {
    const type = MODULE_TYPES[module];
    if (type !== 'application') return false;

    const value = this.getProperty(`Nexus${module}`);
    return !!value?.startsWith('1');
  }

  isFullAccess(module: NexusModule): boolean {
    const type = MODULE_TYPES[module];
    if (type !== 'application') return false;

    const value = this.getProperty(`Nexus${module}`);
    return !!value?.startsWith('2');
  }
}
